const defaultMusic = { // 默认配乐属性
    title: "未命名",
    startEffect: 0,
    endEffect: 0,
    favorites:null
}
const defaultDubbing = {}
const state = {
    loopSoundtrackStatus: false, // 一键循环配乐
    soundtrackState: false,//弹框类型
    timeBarType: 'noSet',//时间轴点击类型,noSet是没有选中,bgm是配乐,dub是配乐,subtitle是字幕
    receiveData: {},//时间轴点击时传的数据
    soundPlayHandle: {}, // 所有声音控制器
    music: [], // 配乐数组
    musicIndex: -1, // 当前选中的配乐位置
    selectMusic: null, // 当前选中的配乐
    dubbing: [], // 配音数组
    dubbingIndex: -1, // 当前选中的配音位置
    selectDubbing: null, // 当前选中的配音
    noRemind: false,//弹框不在提示
    totalTime: 30 // 配乐总时长
}
const getters = {
    getTotalTime: state => state.totalTime,
    getSoundtrackState: state => state.soundtrackState,//获取弹框展开状态
    getTimeBarType: state => state.timeBarType,//获取点击时间轴类型
    getReceiveData: state => state.receiveData,//点击时间轴时传递数据
    getMusicVolume: state => state.soundPlayHandle.musicVolume,
    getMusicArr: state => state.music,
    getMusicIndex: state => state.musicIndex,
    getSelectMusic: state => state.selectMusic, // 当前选中的配乐
    getDubbingVolume: state => state.soundPlayHandle.dubbingVolume,
    getDubbingArr: state => state.dubbing,
    getDubbingIndex: state => state.dubbingIndex,
    getSelectDubbing: state => state.selectDubbing, //当前选中的配音
    getNoRemind() {
        state.noRemind = localStorage.getItem('noRemind')
        return state.noRemind
    },
    getPlayHandle: state => state.soundPlayHandle
}


const mutations = {
    clearSound(state,data) {
        state.soundPlayHandle.clearSound(data);
    },
    setLoopUndoRedo (state,data) {
        if (data.action === 'loop') {
            state.loopSoundtrackStatus = data.type === 'redo';
        }
        state.soundPlayHandle.loopMusic(data.musics);
        setTimeout(() => {
            state.music.push(0);
            state.music.pop();
        }, 2);
    },
    setTotalTime (state,data) {
        state.totalTime = data;
    },
    setLoopSoundtrackStatus (state,data) {
        state.loopSoundtrackStatus = data;
        state.soundPlayHandle.musicLoop = data;
    },
    setLoopSoundtrackAction (state, data) {
        state.loopSoundtrackStatus = true;
        state.soundPlayHandle.musicLoop = true;
        let selectMusic = data.type === 'open' ? state.selectMusic: state.music[0];
        let music = [];
        state.soundPlayHandle.clearSound('music');
        music.push(Object.assign({}, defaultMusic, selectMusic, {timeSlot: [0, data.type === 'totalChange' ? data.totalTime:state.totalTime]}));
        state.soundPlayHandle.loopMusic(music);
        state.selectMusic = null;
        state.musicIndex = -1;
    },
    setSoundObj(state, soundPlayHandle) {
        state.soundPlayHandle = soundPlayHandle;
        state.music = soundPlayHandle.music;
        state.dubbing = soundPlayHandle.dubbing;
        state.loopSoundtrackStatus = soundPlayHandle.musicLoop;
    },
    chooseMusicLoop (state, data) {
        let music = [];
        state.loopSoundtrackStatus = true;
        state.soundPlayHandle.musicLoop = true;
        state.soundPlayHandle.clearSound('music');
        console.log('data', data, state.totalTime);
        music.push({...data, cut: [0, data.duration],timeSlot: [0, state.totalTime]});
        state.soundPlayHandle.loopMusic(music);
    },
    setSoundtrackState(state, data) {
        state.soundtrackState = data.state;
        state.timeBarType = data.type ? data.type : state.timeBarType;
        state.receiveData = state.soundtrackState == true ? data : state.receiveData
    },
    addMusic(state, data) {
        // data: {music: {}, index: 1} index 可不传（在末尾添加）
        if (!data || !data.music) return;
        if (typeof data.index !== 'number') {
            data.index = state.music.length;
        }
        state.soundPlayHandle.addMusic(Object.assign({}, defaultMusic, data.music), data.index);
    },
    setMusicIndex(state, index) {
        state.musicIndex = typeof index === 'number' ? index : -1;
        if (state.music[state.musicIndex]) {
            state.selectMusic = state.music[state.musicIndex];
        } else {
            state.selectMusic = null;
        }
    },
    delMusic(state, index) {
        // 根据index(index 可不传 删除当前选中的配乐) 删除配乐
        let delIndex = index !== undefined ? index : state.musicIndex;
        if (delIndex < 0) return;
        state.musicIndex = -1;
        state.selectMusic = null;
        state.soundPlayHandle.delMusic(delIndex);
    },
    updateMusic(state, data) {
        // data: {music: {}, index: 1} index 可不传（为当前选中的）
        if (typeof data.index !== 'number') {
            data.index = state.musicIndex;
        }
        state.soundPlayHandle.updateMusic(data.music, data.index);
    },

    addDubbing(state, data) {
        // data: {dubbing: {}, index: 1} index 可不传（在末尾添加）
        if (!data || !data.dubbing) return;
        if (typeof data.index !== 'number') {
            data.index = state.dubbing.length;
        }
        state.soundPlayHandle.addDubbing(Object.assign({}, defaultDubbing, data.dubbing), data.index)
    },
    addDubbingGroup(state, data) {
        // data: {dubbings: [{}, {}], index: 1} index 可不传（在末尾添加）
        if(!data || !data.dubbings) return;
        state.soundPlayHandle.addDubbingGroup(data.dubbings, data.index, data.delNum);
    },
    setDubbingIndex(state, index) {
        state.dubbingIndex = typeof index === 'number' ? index : -1;
        if (state.dubbing[state.dubbingIndex]) {
            state.selectDubbing = state.dubbing[state.dubbingIndex];
        } else {
            state.selectDubbing = null;
        }
    },
    delDubbing(state, index) {
        // 根据index(index 可不传 删除当前选中的配音) 删除配音
        let delIndex = index !== undefined ? index : state.dubbingIndex;
        if (delIndex < 0) return;
        state.dubbingIndex = -1;
        state.selectDubbing = null;
        state.soundPlayHandle.delDubbing(delIndex);
    },
    updateDubbing(state, data) {
        // data: {dubbing: {}, index: 1} index 可不传（为当前选中的）
        if (typeof data.index !== 'number') {
            data.index = state.dubbingIndex;
        }
        state.soundPlayHandle.updateDubbing(data.dubbing, data.index);
    },
    changeVolume(state, data) {
        state[`${data.type}Volume`] = data.volume;
        state.soundPlayHandle.changeVolume(data.type, data.volume);
    },
    setNoRemind(state, data) {
        state.noRemind = data
        localStorage.setItem('noRemind', Boolean(data))
    }
}
export default {
    namespaced: true,
    state,
    getters,
    mutations
};




// WEBPACK FOOTER //
// ./src/store/modules/addSoundtrack.js